// src/pages/dizimo/Dizimo.js

import React, { useState } from 'react';
import { maskPhone } from '../../utils/helpers';
import { cadastrarDizimista } from '../../services/api';
import Toast from '../../components/common/Toast';

const COMUNIDADES = [
  'Matriz',
  'Menino Jesus',
  'Santa Teresinha',
  'Nossa Senhora de Fátima – Canaã',
  'Nossa Senhora das Graças – Paupina'];

const Dizimo = () => {
  const [form, setForm] = useState({
    nome: '', telefone: '', dataNascimento: '',
    sexo: '', comunidade: '', endereco: '', bairro: '', cidade: 'Fortaleza',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const [enviado, setEnviado] = useState(false);

  const set = (field, value) => {
    setForm(f => ({ ...f, [field]: value }));
    if (errors[field]) setErrors(e => ({ ...e, [field]: '' }));
  };

  const validate = () => {
    const e = {};
    if (!form.nome.trim())     e.nome = 'Nome é obrigatório.';
    if (!form.telefone.trim()) e.telefone = 'Telefone é obrigatório.';
    if (!form.dataNascimento)  e.dataNascimento = 'Data de nascimento é obrigatória.';
    if (!form.sexo)            e.sexo = 'Selecione o sexo.';
    if (!form.comunidade)      e.comunidade = 'Selecione sua comunidade.';
    if (!form.endereco.trim()) e.endereco = 'Endereço é obrigatório.';
    return e;
  };

  const handleSubmit = async () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    setLoading(true);
    try {
      await cadastrarDizimista(form);
      setEnviado(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch {
      setToast({ msg: 'Erro ao enviar cadastro. Tente novamente.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  if (enviado) {
    return (
      <main style={{ paddingTop: '72px' }}>
        <section style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'var(--space-3xl) var(--space-xl)' }}>
          <div style={{ textAlign: 'center', maxWidth: 520 }}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🙏</div>
            <h2 style={{ marginBottom: '1rem' }}>Cadastro realizado!</h2>
            <p style={{ marginBottom: '2rem' }}>
              Obrigado por se tornar um dizimista da Paróquia Nossa Senhora da Conceição.
              Que Deus abençoe generosamente a sua família!
            </p>
            <button className="btn btn-primary btn-lg" onClick={() => {
              setEnviado(false);
              setForm({ nome:'', telefone:'', dataNascimento:'', sexo:'', comunidade:'', endereco:'', bairro:'', cidade:'Fortaleza' });
            }}>
              Novo cadastro
            </button>
          </div>
        </section>
      </main>
    );
  }

  return (
    <main style={{ paddingTop: '72px' }}>
      {toast && <Toast message={toast.msg} type={toast.type} onClose={() => setToast(null)} />}

      {/* Hero */}
      <section style={{
        background: 'linear-gradient(135deg, var(--navy-dark) 0%, var(--navy) 100%)',
        padding: 'var(--space-2xl) var(--space-xl)',
        textAlign: 'center', position: 'relative', overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: 'radial-gradient(circle, rgba(201,160,48,0.07) 1px, transparent 1px)',
          backgroundSize: '40px 40px', pointerEvents: 'none',
        }} />
        <div style={{ position: 'relative' }}>
          <div className="ornament" style={{ justifyContent: 'center', marginBottom: '0.75rem' }}>Dízimo</div>
          <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>🙏</div>
          <h1 style={{ color: 'var(--white)', marginBottom: '0.5rem' }}>Seja um Dizimista</h1>
          <p style={{ color: 'rgba(255,255,255,0.7)', maxWidth: 560, margin: '0 auto', lineHeight: 1.8 }}>
            O dízimo é uma expressão de fé e gratidão a Deus. Ao contribuir com 10% de sua renda,
            você sustenta a missão da paróquia e ajuda a transformar vidas.
          </p>
        </div>
      </section>

      {/* Cards convite */}
      <section style={{ background: 'var(--off-white)', padding: 'var(--space-xl) var(--space-xl)' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 'var(--space-lg)' }}>
            {[
              { icon: '🙏', titulo: 'Ato de Fé',    texto: 'O dízimo é uma forma concreta de reconhecer que tudo que temos vem de Deus e a Ele pertence.' },
              { icon: '🤝', titulo: 'Comunidade',   texto: 'Sua contribuição sustenta as obras sociais, a manutenção das comunidades e a evangelização.' },
              { icon: '💛', titulo: 'Gratidão',     texto: 'Dizimar é responder ao amor de Deus com generosidade, confiando na Sua providência.' },
            ].map(({ icon, titulo, texto }) => (
              <div key={titulo} className="card" style={{ padding: 'var(--space-xl)', textAlign: 'center', borderTop: '4px solid var(--gold)' }}>
                <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>{icon}</div>
                <h4 style={{ marginBottom: '0.5rem' }}>{titulo}</h4>
                <p style={{ fontSize: '0.9rem' }}>{texto}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Versículo + Formulário */}
      <section style={{ background: 'var(--white)', padding: 'var(--space-xl) var(--space-xl)' }}>
        <div className="container" style={{ maxWidth: 900 }}>

          {/* Versículo */}
          <div style={{
            background: 'linear-gradient(135deg, var(--navy) 0%, var(--navy-light) 100%)',
            borderRadius: 'var(--radius-xl)', padding: 'var(--space-xl) var(--space-2xl)',
            textAlign: 'center', marginBottom: 'var(--space-xl)',
          }}>
            <p style={{ color: 'var(--gold-light)', fontSize: '1.1rem', fontFamily: 'var(--font-display)', fontStyle: 'italic', lineHeight: 1.8, marginBottom: '0.5rem' }}>
              "Trazei todos os dízimos à casa do tesouro, para que haja mantimento na minha casa,
              e provai-me nisto, diz o Senhor dos Exércitos."
            </p>
            <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.85rem' }}>Malaquias 3:10</span>
          </div>

          {/* Formulário */}
          <div className="form-card-mobile" style={{ background: 'var(--white)', borderRadius: 'var(--radius-xl)', boxShadow: 'var(--shadow-md)', padding: 'var(--space-2xl)' }}>
            <h2 style={{ marginBottom: '0.25rem' }}>Cadastro de Dizimista</h2>
            <p style={{ marginBottom: 'var(--space-lg)' }}>Preencha seus dados para se cadastrar como dizimista da paróquia.</p>

            {/* Dados pessoais — grid horizontal */}
            <h4 style={{ color: 'var(--navy)', marginBottom: 'var(--space-md)', paddingBottom: '0.5rem', borderBottom: '2px solid var(--gold-pale)' }}>Dados Pessoais</h4>

            <div className="form-group">
              <label className="form-label">Nome completo <span className="required">*</span></label>
              <input type="text" className={`form-input${errors.nome ? ' error' : ''}`}
                value={form.nome} onChange={e => set('nome', e.target.value)} placeholder="Seu nome completo" />
              {errors.nome && <p className="form-error">{errors.nome}</p>}
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 'var(--space-md)', marginBottom: 'var(--space-md)' }}>
              <div className="form-group" style={{ margin: 0 }}>
                <label className="form-label">Telefone / WhatsApp <span className="required">*</span></label>
                <input type="tel" className={`form-input${errors.telefone ? ' error' : ''}`}
                  value={form.telefone} onChange={e => set('telefone', maskPhone(e.target.value))}
                  placeholder="(85) 99000-0000" maxLength={15} />
                {errors.telefone && <p className="form-error">{errors.telefone}</p>}
              </div>
              <div className="form-group" style={{ margin: 0 }}>
                <label className="form-label">Data de Nascimento <span className="required">*</span></label>
                <input type="date" className={`form-input${errors.dataNascimento ? ' error' : ''}`}
                  value={form.dataNascimento} onChange={e => set('dataNascimento', e.target.value)} />
                {errors.dataNascimento && <p className="form-error">{errors.dataNascimento}</p>}
              </div>
              <div className="form-group" style={{ margin: 0 }}>
                <label className="form-label">Sexo <span className="required">*</span></label>
                <select className={`form-select${errors.sexo ? ' error' : ''}`}
                  value={form.sexo} onChange={e => set('sexo', e.target.value)}>
                  <option value="">Selecione...</option>
                  <option value="Masculino">Masculino</option>
                  <option value="Feminino">Feminino</option>
                </select>
                {errors.sexo && <p className="form-error">{errors.sexo}</p>}
              </div>
              <div className="form-group" style={{ margin: 0 }}>
                <label className="form-label">Comunidade <span className="required">*</span></label>
                <select className={`form-select${errors.comunidade ? ' error' : ''}`}
                  value={form.comunidade} onChange={e => set('comunidade', e.target.value)}>
                  <option value="">Selecione...</option>
                  {COMUNIDADES.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
                {errors.comunidade && <p className="form-error">{errors.comunidade}</p>}
              </div>
            </div>

            {/* Endereço */}
            <h4 style={{ color: 'var(--navy)', margin: 'var(--space-lg) 0 var(--space-md)', paddingBottom: '0.5rem', borderBottom: '2px solid var(--gold-pale)' }}>Endereço</h4>

            <div className="form-group">
              <label className="form-label">Rua / Avenida e número <span className="required">*</span></label>
              <input type="text" className={`form-input${errors.endereco ? ' error' : ''}`}
                value={form.endereco} onChange={e => set('endereco', e.target.value)}
                placeholder="Ex: Rua das Flores, 100" />
              {errors.endereco && <p className="form-error">{errors.endereco}</p>}
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-md)', marginBottom: 'var(--space-lg)' }}>
              <div className="form-group" style={{ margin: 0 }}>
                <label className="form-label">Bairro</label>
                <input type="text" className="form-input" value={form.bairro}
                  onChange={e => set('bairro', e.target.value)} placeholder="Seu bairro" />
              </div>
              <div className="form-group" style={{ margin: 0 }}>
                <label className="form-label">Cidade</label>
                <input type="text" className="form-input" value={form.cidade}
                  onChange={e => set('cidade', e.target.value)} />
              </div>
            </div>

            <button className="btn btn-primary btn-lg"
              style={{ width: '100%', justifyContent: 'center' }}
              onClick={handleSubmit} disabled={loading}>
              {loading ? 'Enviando...' : '🙏 Quero ser dizimista'}
            </button>

            <p style={{ textAlign: 'center', marginTop: '0.75rem', fontSize: '0.82rem', color: 'var(--gray-400)' }}>
              Seus dados são usados apenas pela paróquia e nunca serão compartilhados.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Dizimo;